export default "/JMMMU/japanese_heritage.7aae8b68-9d9e84.jpg";